import { render, staticRenderFns } from "./admin_xcp.vue?vue&type=template&id=297d13e9&scoped=true"
import script from "./admin_xcp.vue?vue&type=script&lang=js"
export * from "./admin_xcp.vue?vue&type=script&lang=js"
import style0 from "./admin_xcp.vue?vue&type=style&index=0&id=297d13e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d13e9",
  null
  
)

export default component.exports